// src/App.jsx
import { useState } from "react";
import { LoadScript } from "@react-google-maps/api";
import AppRoutes from "./routes/AppRoutes";
import { UserProvider } from "./contexts/UserContext";
import "./index.css";

const libraries = ["places"];

export default function App() {
  const [scriptLoaded, setScriptLoaded] = useState(false);

  return (
    <UserProvider>
      <LoadScript
        googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
        libraries={libraries}
        onLoad={() => {
          console.log("✅ Google Maps script loaded");
          setScriptLoaded(true);
        }}
        onError={(err) =>
          console.error("❌ Failed to load Google Maps script:", err)
        }
      >
        <AppRoutes scriptLoaded={scriptLoaded} />
      </LoadScript>
    </UserProvider>
  );
}
